var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractLogger, LogLevel } from './AbstractLogger';
export var levels = {
    silent: 0,
    fatal: 1,
    error: 2,
    warn: 3,
    info: 4,
    debug: 5,
    trace: 6
};
var WinstonLogger = (function (_super) {
    __extends(WinstonLogger, _super);
    function WinstonLogger(logger, name) {
        if (name === void 0) { name = ''; }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.logger = logger;
        _this.trace = Function.prototype.bind.call(logger.trace, logger);
        _this.debug = Function.prototype.bind.call(logger.debug, logger);
        _this.info = Function.prototype.bind.call(logger.info, logger);
        _this.warn = Function.prototype.bind.call(logger.warn, logger);
        _this.error = Function.prototype.bind.call(logger.error, logger);
        _this.fatal = Function.prototype.bind.call(logger.fatal, logger);
        return _this;
    }
    WinstonLogger.prototype.setLevel = function (level) {
        this.level = level;
        if (this.logger) {
            this.logger.level = LogLevel[level].toLowerCase();
        }
    };
    WinstonLogger.getLogger = function (name) {
        if (name === void 0) { name = ''; }
        var loggerExists = AbstractLogger.loggers.hasOwnProperty(name);
        return loggerExists ? AbstractLogger.loggers[name] : null;
    };
    return WinstonLogger;
}(AbstractLogger));
export { WinstonLogger };
//# sourceMappingURL=WinstonLogger.js.map